import axios from "axios";
import { API_URL } from "../../const";
export const searchBusinessDetailsAPI = (payload: any) => {
  const data = {
    GetBusinessDetailsToken: payload,
  };

  const url = `${API_URL}GetViewBusinessDetails`;
  return axios.post(url, data, {
    headers: { "content-type": "application/json" },
  });
};
